export function SET_USER(state, user) {
  state.usuario = { ...user };
  localStorage.setItem('state', JSON.stringify(state))

  if (localStorage.getItem('externalLink')) {
    let el = localStorage.getItem('externalLink')
    localStorage.removeItem('externalLink')
    window.location = el
  }
}

export function SET_PENDENCY(state, pendency) {
  state.usuario.pendency = { ...pendency };
  localStorage.setItem('state', JSON.stringify(state))
}

export function SET_PERFIL(state, perfil) {
  state.perfil = perfil
}
export function SET_DOCS(state, docs) {
  state.docs = { ...docs }
}
export function SET_BANK(state, bank) {
  state.bank = { ...bank }
}
export function SET_LOGIN(state, status) {
  state.auth = status;
}

export function SET_LOGOUT(state, exit) {
  state.usuario = {};
  state.auth = {};
  let token = localStorage.getItem('token') || false
  let modals = {
    atendimento: localStorage.getItem('atendimento'),
    equipe: localStorage.getItem('equipe')
  }

  localStorage.clear();
  for (let m in modals)
    localStorage.setItem(m, modals[m]);


  if (token) localStorage.setItem('token', token)
  window.location = exit || '/'
}

export function SET_COMPETENCE(state, competence) {
  state.competence = competence;
}


export function SET_EXTRACT(state, extract) {
  state.extract = extract
}

export function SET_CERTIFICATES(state, certificates) {
  state.certificates = certificates;
}
export function SET_TOOLS(state, tools) {
  state.tools = tools;
}